import { ButtonStyle, ControlSize, ControlType, Property, PropertyType } from "../../../base/types";

import { DefaultLabel } from "../../widgets";
import { DesignerMode } from "../../types";
import { FC } from "react";
import { IControlAttributes } from "../../../base/models";
import { MUIIcon } from "../../../widgets";
import { Registry } from "../../../base/register";
import clsx from "clsx";
import { getButtonClass } from "../buttons/helper";
import { useGetProperties } from "../../../base/hooks";

export const HyperLinkComponent: FC<IControlAttributes> = ({
    control, className, children, props, designerMode, ...rest
}) => {
    const { properties } = useGetProperties({ bindings: control.bindings });
    const label: string | undefined = properties[Property.Label];
    const tooltip: string | undefined = properties[Property.Tooltip];
    const url: string | undefined = properties[Property.Url];
    const target: string | undefined = properties[Property.Target];
    const icon: string | undefined = properties[Property.MaterialIcon]
    const style: ButtonStyle | undefined = properties[Property.BackgroundStyle]
    const size: ControlSize | undefined = properties[Property.Size]

    if (designerMode === DesignerMode.Draft) {
        return (
            <div className={clsx(getButtonClass(style, size, "btn btn-link btn-sm"), className)} title={tooltip}>
                {(icon) && <MUIIcon iconName={icon} className={clsx({ "me-1": !!label })} />}
                <DefaultLabel
                    control={control}
                    propertyId={Property.Label}
                    defaultLabel="Hyper Link"
                    className="text-hover-primary bg-secondary" />
                {children}
            </div>)
    }

    return (
        <a className={clsx(getButtonClass(style, size, "btn btn-link btn-sm"), className)} title={tooltip} href={url} target={target}>
            {(icon) && <MUIIcon iconName={icon} className={clsx({ "me-1": !!label })} />}
            <span>{label}</span>
            {children}
        </a >)
}

Registry.addControl({
    id: "1cd84e2f-d110-431c-a96f-b7e6555411af",
    name: "Hyperlink",
    type: ControlType.Hyperlink,
    properties: [
        { id: Property.MaterialIcon, name: 'Icon', type: PropertyType.MaterialIcon },
        { id: Property.Label, name: 'Label', type: PropertyType.String },
        { id: Property.Url, name: 'Url', type: PropertyType.String },
        { id: Property.Target, name: 'Target', type: PropertyType.String },
        { id: Property.Tooltip, name: 'Tooltip', type: PropertyType.String },
        { id: Property.BackgroundStyle, name: 'Style', type: PropertyType.ButtonStyle },
        { id: Property.Size, name: 'Size', type: PropertyType.ControlSize },
    ],
    component: HyperLinkComponent
})
